import ajax from '@/utils/ajax'

/**
 * @module 经营分析接口
 */

// 所有资源列表
export const getAllResources = (params) => ajax.post(`/resourceShortcut/listResources`, params)

// 用户自定义列表
export const getUserResources = (params) => ajax.post(`/resourceShortcut/listCustomerResources`, params)

// 保存资源列表
export const saveResources = (params) => ajax.post(`/resourceShortcut/addResources`, params)

// 实时数据
export const getRealtimeData = (params) => ajax.post(`/business/analysis/realTimeData`, params)

// 实时数据折线图
export const getRealtimeChart = (params) => ajax.post(`/business/analysis/cumulativeSales`, params)

// 团油带来车主
export const getUserDistribution = (params) => ajax.post(`/business/analysis/tyBringDriver`, params)

// 实时行为
export const getRealTimeBehavior= (params) => ajax.post(`/business/analysis/realTimeAction`, params)

// 总销售额
export const getTotalSales = (params) => ajax.post(`/business/analysis/salesAmount`, params)

// 交易笔数
export const getNumOfBusiness = (params) => ajax.post(`/business/analysis/dealNum`, params)

// 用户分布
export const getUserMap = params => ajax.post('portrayal/portrayalUserDistribution', params)

// 首页权限控制
export const homePageFunction = params => ajax.post('login/homePageFunction', params)

// 按钮控制权限
export const getBtnJurisdiction = params => ajax.post('business/analysis/isPermission', params)

// 获取定时器时间
export const getTimeout = params => ajax.post('business/analysis/refreshTime', params)

// 获取短信套餐详情
export const getSmsPackageDetail = params => ajax.post('business/analysis/smsPackageDetail', params)
